import NextError from "next/error";
import Custom404 from "../Custom404";

const statusCodes = {
  400: "Bad Request",
  405: "Method Not Allowed",
  500: "Internal Server Error",
};

const CustomError = ({ statusCode }) => {
  if (statusCode === 404) {
    return <Custom404 />;
  }

  const title = statusCodes[statusCode] || "Oups, une erreur est survenue";

  return (
    <NextError
      title={title}
      statusCode={statusCode || "¯\\_(ツ)_/¯"}
    />
  );
};

export default CustomError;
